/* eslint-disable react/button-has-type */
/* eslint-disable no-unused-vars */
import React, { useState, useCallback } from 'react';
import useQlikApp from 'hooks/useQlikApp';
import { styled } from '@mui/system';
import questionsData from 'utils/questions';
import AppContext from './AppContext';

import Header from './Sections/Header/Header';

// import Dashboard from './Sections/Dashboard';
// import Questions from './Sections/Questions';

import SideBar from './Sections/SideBar';
import Main from './Sections/Main';
import Footer from './Sections/Footer';

const AppWrapper = styled('div', {})(({ theme }) => ({
  backgroundColor: '#f1f1f1',
  // backgroundImage: 'url("assets/images/Art_CubesConnections.png")',
  // backgroundRepeat: 'no-repeat',
  // backgroundSize: '65%',
  // backgroundPosition: '175% 135%',
  width: '100%',
  '#fp-nav': {
    color: '#333 !important',
  },
}));

const ContentWrapper = styled('div', {})(({ theme }) => ({
  // backgroundColor: 'pink',
  paddingTop: '40px',
}));

const App = () => {
  const qlikApp = useQlikApp();

  const [selectedGroup, setSelectedGroup] = useState('General');

  const [percentageChecked, setPercengeChecked] = useState(true);

  const groupMap = new Map(questionsData.map((item) => [item.group, item.group]));
  const groups = ['General', ...Array.from(groupMap.values())];

  const handleGroupClick = (group) => {
    setSelectedGroup(group);
  };

  return (
    <AppContext.Provider value={{ qlikApp }}>
      <AppWrapper>

        <Header />

        <ContentWrapper>
          <SideBar groups={groups} onGroupClick={handleGroupClick} selectedGroup={selectedGroup} percentageChecked={percentageChecked} setPercengeChecked={setPercengeChecked} />
          <Main group={selectedGroup} percentageChecked={percentageChecked} />
        </ContentWrapper>

        <Footer />

      </AppWrapper>

    </AppContext.Provider>
  );
};

App.propTypes = {};

export default App;
